"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHMenuSpec = void 0;
const KHEventHandler_1 = require("../KHEventHandler");
const KHHelperFunctions_1 = require("../KHHelperFunctions");
const KHMenuOption_1 = require("./KHMenuOption");
class KHMenuSpec extends KHEventHandler_1.KHEventHandler {
    constructor(title, menuEntries, lastEntry = null) {
        super([KHMenuSpec.UPDATE_SELECTION, KHMenuSpec.UPDATE_DESCRIPTION, KHMenuSpec.UPDATE_SELECTION_OPTION]);
        this.allOptions = [];
        this.options = [];
        this.selectedIndex = -1;
        this.title = title;
        this.options.push(...menuEntries);
        this.allOptions.push(...this.options);
        if (lastEntry) {
            this.allOptions.push(lastEntry);
            this.lastOption = lastEntry;
        }
        this.allOptions.forEach(element => {
            element.registerCallback(KHMenuOption_1.KHMenuOption.UPDATE_SELECTION_OPTION, (data) => {
                this.sendUpdateDescriptionEvent(this.allOptions[this.selectedIndex]);
                this.emitEvent(KHMenuOption_1.KHMenuOption.UPDATE_SELECTION_OPTION, { userInitiated: data.userInitiated, option: data.option, selectionIndex: data.selectionIdx });
            });
        });
        this.setNextIndex(false);
    }
    getDescription() {
        let current = this.allOptions[this.selectedIndex];
        if (current) {
            return current.getDescription();
        }
        return "";
    }
    setSelected(menuOption, userInitiated = true) {
        let newIndex = this.allOptions.indexOf(menuOption);
        this.setSelectedIndex(newIndex);
    }
    sendSelectPreviousToCurrentOption() {
        let option = this.allOptions[this.selectedIndex];
        if (option) {
            if (option.back_callback) {
                option.back_callback();
            }
        }
    }
    sendSelectNextToCurrentOption() {
        let option = this.allOptions[this.selectedIndex];
        if (option) {
            if (option.callback) {
                option.callback();
            }
        }
    }
    setPreviousIndex(userInitiated = true) {
        for (let i = 1; i <= this.allOptions.length; i++) {
            const adj_idx = KHHelperFunctions_1.inRange(this.selectedIndex - i, this.allOptions.length);
            if (this.allOptions[adj_idx].getSelectable()) {
                this.setSelectedIndex(adj_idx, userInitiated);
                return;
            }
        }
    }
    setNextIndex(userInitiated = true) {
        for (let i = 1; i <= this.allOptions.length; i++) {
            const adj_idx = KHHelperFunctions_1.inRange(this.selectedIndex + i, this.allOptions.length);
            if (this.allOptions[adj_idx].getSelectable()) {
                this.setSelectedIndex(adj_idx, userInitiated);
                return;
            }
        }
    }
    setSelectedIndex(index, userInitiated = true) {
        if (index < 0 || index >= this.allOptions.length) {
            index = -1;
        }
        let lastIndex = this.selectedIndex;
        let last = this.allOptions[this.selectedIndex];
        last === null || last === void 0 ? void 0 : last.setSelected(false);
        this.selectedIndex = index;
        let current = this.allOptions[this.selectedIndex];
        current === null || current === void 0 ? void 0 : current.setSelected(true);
        this.emitEvent(KHMenuSpec.UPDATE_SELECTION, { index: this.selectedIndex, lastIndex: lastIndex, option: current, lastOption: last, userInitiated: userInitiated });
        this.sendUpdateDescriptionEvent(current);
    }
    sendUpdateDescriptionEvent(current) {
        var _a;
        this.emitEvent(KHMenuSpec.UPDATE_DESCRIPTION, { description: (_a = current === null || current === void 0 ? void 0 : current.getDescription()) !== null && _a !== void 0 ? _a : "" });
    }
    /**
     * Returns a list of menu options. Changes to this list will not be
     * reflected in the menu spec.
     */
    getOptions() {
        return [...this.options];
    }
    getLastOption() {
        return this.lastOption;
    }
}
exports.KHMenuSpec = KHMenuSpec;
KHMenuSpec.UPDATE_SELECTION = "us";
KHMenuSpec.UPDATE_SELECTION_OPTION = "uso";
KHMenuSpec.UPDATE_DESCRIPTION = "ud";
